// extracted by mini-css-extract-plugin
export default {"container":"loading_container__fuflD","loader":"loading_loader__l2wGF","spin":"loading_spin__eqE0i","message":"loading_message__dWKAM"};